export const PresetPages = [
    { uuid: 'bio', label: 'Анкета пользователя', type: 'PageBio' },
    { uuid: 'login', label: 'Вход в систему', type: 'PageLogin' },
    { uuid: 'course', label: 'Курс', type: 'PageCourse' },
    { uuid: 'task', label: 'Тема (задание)', type: 'PageTask' },
    { uuid: 'tasks', label: 'Задания (список)', type: 'PageTasks' },
    { uuid: 'buy-course', label: 'Покупка курса', type: 'PageBuyCourse' },
    { uuid: 'pay-course', label: 'Оплата курса', type: 'PagePayForCourse' },
    { uuid: 'buy-success', label: 'Поздравляем!', type: 'PageBuySuccess' },
    { uuid: 'my-courses', label: 'Мои курсы', type: 'PageMyCourses' },
    { uuid: 'subscription_page', label: 'Подписка', type: 'PageSubscription' },
    { uuid: 'buy-subscription', label: 'Покупка подписки', type: 'PageBuySubscription' },
    {
        uuid: 'cert2', label: 'Сертификат', type: 'PageCertificate2', hidden: true,
    },
    {
        uuid: 'confirm-tel', label: 'Страница подтверждения номера телефона', type: 'PageConfirmTel', hidden: true,
    },
    {
        uuid: 'confirm-vk', label: 'Страница запроса разрешения на сообщения ВК', type: 'PageConfirmVk', hidden: true,
    },
];

export function getPresetPage (uuid) {
    for (let i = 0; i < PresetPages.length; i += 1) {
        const p = PresetPages[i];
        if (uuid === p.uuid) {
            return p;
        }
    }
    return undefined;
}

export default getPresetPage;
